import React from 'react';
import { connect } from "react-redux";
import { Trans } from 'react-i18next';
import FXPLogo from '../Common/FXPLogo';
import moment from 'moment';

const ReleaseNotesOverlay = (props) => {
    const [latestReleaseNote, ...previousReleaseNotes] = props.userSession.user.release_notes || [];

    const createMarkup = (release) => ({ __html: release.content });

    if (!latestReleaseNote) {
        if (props.closeModal) props.closeModal();
        return null;
    }

    return (
        <div className = "reveal" id = "release-overlay" style={{display: "block",top:"0", border: 'none', borderRadius: '15px'}}> 
            <div className = "card" style={{borderRadius: '15px', border: 'none'}}>
                <div className = "">
                    <button className="close-button" data-close aria-label='Close modal' type='button' onClick={props.closeModal}>
                        <span aria-hidden='true'>&times;</span>
                    </button>
                </div>
                <div className="card-section release-notes-card">
                    <div className="release-notes-logo align-center" style={{marginLeft: 'auto', marginRight: 'auto', marginBottom: 0}}>
                        <FXPLogo/>
                    </div>
                    <div className="release-notes-content">
                        <div className="release-notes-header" ><Trans>{latestReleaseNote.title} - Version {latestReleaseNote.is_pre_release ? '[Pre-release] ' : ''}{latestReleaseNote.release_tag}</Trans></div>
                        <div className="release-notes-body" dangerouslySetInnerHTML={createMarkup(latestReleaseNote)}></div>
                        {Boolean(previousReleaseNotes?.length) && (
                            <>
                                <div className="release-notes-prev-header"><Trans>Previous Updates</Trans></div>
                                {previousReleaseNotes.map((release)=> (
                                    <div className="release-notes-prev-header-item" key={release.id}>
                                        Version {release.is_pre_release ? '[Pre-release] ' : ''}{release.release_tag} - {moment(release.created_at).format('MMM DD, YYYY')}
                                        <div className="release-notes-body" dangerouslySetInnerHTML={createMarkup(release)}></div>
                                    </div>
                                ))}
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = store => ({
    userSession: store.userSession
})

export default connect(mapStateToProps)(ReleaseNotesOverlay)